import { render, staticRenderFns } from "./UnsavedTripCarousel.vue?vue&type=template&id=761c84e4"
import script from "./UnsavedTripCarousel.vue?vue&type=script&lang=ts"
export * from "./UnsavedTripCarousel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports